import { isEmpty } from "lodash";
import { setManagerData, setManagerScope } from "../redux/slices/school/manager";
import { getManagers } from "../services/school/manager/getManagers";
import { useAppDispatch, useAppSelector } from "./hooks";
import { jwtDecode } from "jwt-decode";
import { TokenResponseType } from "../types/TokenResponse";
import { AUTH_LOCALSTORAGE } from "../utils/constants";
import { consolidateManagerScope } from "../utils/consolidateManagerScope";

export const useFetchManager = () => {
    const dispatch = useAppDispatch();


    const managerData = useAppSelector((state) => state.manager);

    const fetchManager = async () => {
        const token = localStorage.getItem(AUTH_LOCALSTORAGE);
        if (!token) return;
        const decodedToken: TokenResponseType = jwtDecode(token);
        const userId = decodedToken.UserId;
        if (!isEmpty(managerData?.id)) return;
        try {
            const response = await getManagers({ PageSize: 400, PageNumber: 1, IdUser: userId });
            const managersRes = response.items.filter(i => i.idUser === userId);
            const scope = consolidateManagerScope(managersRes);
            dispatch(setManagerScope(scope));
            dispatch(setManagerData({ ...managersRes[0], isManager: true }));

        } catch (error) {
            console.error("Erro ao buscar dados do manager:", error);
        }
    };

    return { fetchManager, managerData };
};